module.exports = __webpack_public_path__ + "img/vartext4en.0e61db09.svg";